export const EscalatorEnergized = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="#363BC4"
      d="M7.747 5.71a1.71 1.71 0 0 1 2.921-1.21 1.71 1.71 0 1 1-2.42 2.42 1.7 1.7 0 0 1-.501-1.21M8.91 19.05H7.062a2.396 2.396 0 0 1-1.694-4.087 2.4 2.4 0 0 1 1.694-.701h.342v-4.105a2.052 2.052 0 0 1 3.506-1.451c.385.385.601.907.601 1.451v.684l1.41-1.585a3.42 3.42 0 0 1 2.56-1.151h1.849a2.396 2.396 0 0 1 1.694 4.087c-.45.45-1.059.701-1.694.701h-1.096a.7.7 0 0 0-.512.23l-4.25 4.78A3.42 3.42 0 0 1 8.91 19.05m-.137-5.13 1.37-1.54v-2.223a.684.684 0 0 0-1.37 0zm-1.71 3.762H8.91a2.05 2.05 0 0 0 1.535-.689l4.25-4.779a2.06 2.06 0 0 1 1.54-.689h1.095a1.027 1.027 0 1 0 0-2.052h-1.848a2.06 2.06 0 0 0-1.535.689l-4.25 4.779a2.05 2.05 0 0 1-1.54.689H7.062a1.027 1.027 0 1 0 0 2.052"
    />
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.65 14.353h-1.91c-.06 0-.09 0-.115.008a.2.2 0 0 0-.063.032.3.3 0 0 0-.06.085l-1.394 2.372c-.063.108-.095.162-.087.206a.14.14 0 0 0 .069.095c.043.026.114.026.256.026h2.06L16.41 20l4.047-3.57c.137-.12.205-.18.21-.232a.13.13 0 0 0-.06-.117c-.046-.034-.144-.034-.34-.034h-2.363z"
    />
  </svg>
);
